import React from "react";
import { Box, Typography } from "@mui/material";
import HeaderLogo from "../common/HeaderLogo";
import MarketingContent from "../login/MarketingContent";
import "../login/stylesLogin.scss";

/**
 * Shared login page chrome (logo, form panel, marketing column).
 */
export default function AuthShell({ children, title = "Welcome!" }) {
  return (
    <Box display="flex" minHeight="100vh" bgcolor="background.default">
      <HeaderLogo />
      <Box flex={1} display="flex" alignItems="center" justifyContent="center">
        <Box
          className="login-wrapper"
          paddingX={6}
          paddingY={6.75}
          borderRadius={2}
          boxShadow={3}
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", sm: "100%", md: "50%" },
          }}
          bgcolor="var(--elevation-outlined, rgba(255, 255, 255, 0.12))"
          border="1px solid var(--elevation-outlined, rgba(255, 255, 255, 0.12))"
        >
          <Typography
            variant="h4"
            mb={2}
            lineHeight={"42px"}
            letterSpacing={"0.25px"}
          >
            {title}
          </Typography>
          {children}
        </Box>
      </Box>
      <MarketingContent />
    </Box>
  );
}
